// 获取作品列表
export const listAll = "/works/worksUpload/listAll";

// 作品状态修改
export const updateStatus = "/works/worksUpload/updateStatus";

// 作品详情
export const prodDetail = (id) => `/works/worksUpload/${id}`;

// 分类
export const getCategorize = "/works/worksUpload/getCategorize";

// 标签
export const getPicture = "/works/worksUpload/getPicture";

// 作品数
export const getWorksCount = "/works/worksUpload/getStatusCounts";

// 编辑作品
export const editWork = "/works/worksUpload/edit-work";
